import React from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';
import { isNotNullOrUndefined } from '@utils/utils.tsx';
import ButtonTag from '@components/framework/tags/ButtonTag.tsx';
import SvgTabMessages from '@components/ringil3/icons/TabMessages.tsx';

interface ComponentProps {
  count: number;
  dataTestId?: string;
}

const RequestedCarriersTag: React.FC<ComponentProps> = ({ count, dataTestId }) => {
  const { tr } = useTranslationLgs();

  return (
    <>
      {isNotNullOrUndefined(count) && (
        <ButtonTag label={tr(`CarrierDemandTag.title`, `Requested carriers`)}
                   value={count}
                   icon={<SvgTabMessages />}
                   dataTestId={dataTestId}
                   readonly={true} />
      )}
    </>
  );
};

export default RequestedCarriersTag;
